import { FC, useContext, useState } from "react";
import { useNavigate } from "react-router-dom";
import Typhography from "../../shared/Typhography/Typhography";
import style from "./ProfilePage.module.scss";
import { CustomSection } from "../../shared/CustomSection/CustomSecton";
import CustomAvatar from "../../shared/CustomAvatar/CustomAvatar";
import { useAppSelector } from "../../store";
import { AuthContext } from "../../providers/authProvider";
import CustomButton from "../../shared/CustomButton/CustomButton";
import { useCustomKeycloak } from "../../hooks/useCustomKeycloak";
import { useEndpoints } from "../../hooks/useEndpoints";
import classNames from "classnames";
import toast from "react-hot-toast";
import { EditProfileModal } from "../../components/ProfilePage/EditProfileModal/EditProfileModal";
import { ManualEntryPreferencesSection } from "./sections/ManualEntryPreferencesSection";
import { GdprSection } from "./sections/GdprSection";

export const ProfilePage: FC = () => {
  const selectedEntity = useAppSelector((st) => st.me.selectedEntity);
  const { isAdmin, isAthlete, isCoach, isDirector, userImage } =
    useContext(AuthContext);
  const { keycloak } = useCustomKeycloak();
  const navigate = useNavigate();
  const [isOpen, setISOpen] = useState(false);

  const onClose = () => {
    setISOpen(false)
  }
  const onOpen = () => {
    setISOpen(true)
  }

  const { forgotPassword } = useEndpoints();

  const onResetPassword = async () => {
    const email = selectedEntity?.email;
    if (!email) return;
    const id = toast.loading(`Reset Password in corso...`, { duration: 20000 });
    try {
      await forgotPassword(email);
      toast.success("Abbiamo inviato un'email per resettare la password", {
        id,
        duration: 6000,
      });
    } catch (error) {
      toast.error("Errore durante il reset della password", {
        id,
        duration: 6000,
      });
    }
  };

  const renderRightUserSection = () => {
    switch (true) {
      case isAdmin:
        return (
          <div className="d-flex flex-column justify-content-center gap-2">
            <Typhography size="bold-24">
              {(selectedEntity as any).directorId.name}
            </Typhography>
            <Typhography size="medium-16">Amministratore</Typhography>
          </div>
        );
      case isAthlete:
        return (
          <div className="d-flex flex-column justify-content-center gap-2">
            <Typhography size="bold-24">
              {(selectedEntity as any).directorId.name}
            </Typhography>
            <Typhography size="medium-16">Atleta</Typhography>
          </div>
        );
      case isCoach:
        return (
          <div className="d-flex flex-column justify-content-center gap-2">
            <Typhography size="bold-24">
              {(selectedEntity as any).directorId.name}
            </Typhography>
            <Typhography size="medium-16">Coach</Typhography>
          </div>
        );
      case isDirector:
        return (
          <div className="d-flex flex-column justify-content-center gap-2">
            <Typhography size="bold-24">
              {(selectedEntity as any).name}
            </Typhography>
            <Typhography size="medium-16">Direttore</Typhography>
          </div>
        );
    }
  };

  return (
    <>
      <div className="container-page">
        <div className="d-flex flex-column mb-3 gap-1">
          <Typhography type="h1" size="bold-24" className={style.title}>
            Profilo
          </Typhography>
          <Typhography size="regular-14" className={style.title}>
            Modifica le informazioni e le impostazioni del tuo profilo
          </Typhography>
        </div>
        <div className="d-flex flex-column gap-2">
          <CustomSection className="p-3">
            <div className="d-flex align-items-center justify-content-between">
              <div className="d-flex gap-2">
                <CustomAvatar
                  textClassName={style.fallbackText}
                  className={style.avatarContainer}
                  name={`${selectedEntity?.firstName[0]}${selectedEntity?.lastName[0]}`}
                  src={userImage}
                />
                {renderRightUserSection()}
              </div>
              <CustomButton color="outline" onClick={onOpen}>Modifica profilo</CustomButton>
            </div>
          </CustomSection>
          <CustomSection className="p-3">
            <Typhography size="bold-20" className="mb-2">
              Impostazioni
            </Typhography>
            <Typhography size="regular-16" className="mb-4">
              Ecco tutte le impostazioni del tuo profilo
            </Typhography>
            <div className={style.nestedSection}>
              <Typhography size="bold-16">Reset della password</Typhography>
              <CustomButton color="outline" onClick={onResetPassword}>
                Reset Password
              </CustomButton>
            </div>
            <div className={style.nestedSection}>
              <Typhography size="bold-16">Supporto e assistenza</Typhography>
              <CustomButton
                color="outline"
                onClick={() => navigate("/dashboard/supporto")}
              >
                Apri ticket
              </CustomButton>
            </div>
            <div className={classNames(style.nestedSection, "pb-2")}>
              <Typhography size="bold-16">Log out</Typhography>
              <CustomButton
                color="outline"
                typeText="danger"
                onClick={() => {
                  keycloak.logout();
                }}
              >
                Log out
              </CustomButton>
            </div>
          </CustomSection>

          {/* Preferenze inserimento manuale — solo per coach/director/admin */}
          {(isCoach || isAdmin || isDirector) && (
            <CustomSection className="p-3">
              <ManualEntryPreferencesSection />
            </CustomSection>
          )}

          {/* GDPR — sempre visibile, ogni utente ha diritto di accesso/cancellazione */}
          <CustomSection className="p-3">
            <GdprSection />
          </CustomSection>
        </div>
      </div>
      <EditProfileModal isOpen={isOpen} onClose={onClose} />
    </>
  );
};
